module.exports = __webpack_public_path__ + "img/title-bg.247580b9.png";